import './index.scss'
import {ReactComponent as LeftArrow} from "../../../assets/logos/left-slide.svg"
import { useState, useEffect } from "react"

const data = [
    {id:"journey7", date:"April 2024", title:"Official Launch", content:"Following a successful beta phase, we launched Walkzero's HRMS to the public. Our comprehensive suite of tools now supports modern organizations in managing their workforce more efficiently than ever.", sublist:[]},
    {id:"journey6", date:"October 2023 to March 2024", title:"Integration and Testing", content:"We focused on integrating all modules into a unified system, conducting thorough testing to ensure reliability, and refining the user experience based on feedback from beta testing.", sublist:[]},
    {id:"journey5", date:"September  2023", title:"Enhancing Employee Engagement", content:"We launched tools to boost employee empowerment and streamline administration:", sublist:[{title:"E-Separation"}]},
    {id:"journey4", date:"August 2023", title:"Revolutionizing Payroll Management", content:"Our payroll system was developed to enhance accuracy and ensure compliance:", sublist:[{title:"CTC Components and Statutory Compliance"}, {title:"Payroll Group Setup and Payslip Templates"}, {title:"Payroll Scheduling"}]},
    {id:"journey3", date:"July 2023", title:"Advanced Attendance Solutions", content:"We introduced advanced tools for managing attendance and work arrangements:", sublist:[{title:"Shift Management and Work From Home Options"}, {title:"On Duty and OverTime Management"}, {title:"Attendance Capture and Tracking with Geo Clockin"}, {title:"Attendance Metrics"}]},
    {id:"journey2", date:"June 2023", title:"Building a Flexible Leave System", content:"We developed a versatile leave management system focusing on work-life balance:", sublist:[{title:"Holiday Planning and Leave Policies"}, {title:"Leave Metrics"}]},
    {id:"journey1", date:"May 2023", title:"Ideation & Blueprinting", content:"The journey kicked off with the goal to simplify workplace operations. We started building a platform with essential modules:", sublist:[{title:"Employee Self Portal (ESS)"}, {title:"Directory and Profile Management"} ]},
]


const OurJourney = () => {

    const [scrollRight, setScrollRight] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [journeyList] = useState(data);

    useEffect(() => {
        const container:any = document.getElementById('journeyContainer');
        const child:any = document.getElementById("childJourney");
        const scrollAmount:number = Math.floor(container?.offsetWidth / child?.offsetWidth)
        const right:number = journeyList.length - scrollAmount
        setScrollRight(right)
        
    }, [journeyList]);


    const slideLeft = () => {
        const container:any = document.getElementById('journeyContainer');
        const childWidth = container.children[0].offsetWidth;

        setScrollLeft(prevScrollLeft => prevScrollLeft - 1);
        setScrollRight(prevScrollRight => prevScrollRight + 1);
       
        container.scrollLeft -= (childWidth + 20)
        
    }

    const slideRight = () => {
        const container:any = document.getElementById('journeyContainer');
        const childWidth = container.children[0].offsetWidth;

        setScrollRight(prevScrollRight => prevScrollRight - 1);
        setScrollLeft(prevScrollLeft => prevScrollLeft + 1);
       
        container.scrollLeft += (childWidth +  20)
    }

    const shouldShowLeftArrow = scrollLeft > 0;
    const shouldShowRightArrow = scrollRight > 0;

    return (
        <div className='w-100 bg-col-shadow-color d-flex flex-column justify-content-center align-items-center m-t-100 m-b-100 max-h'>
            <div className='d-flex flex-row justify-content-between align-items-center align-self-center outer-journey-cont'>
                <div className='journey-cont'>
                    <p className='col-quaternary font-weight-5 text-12 mb-1 text-uppercase'>The Walkzero Evolution</p>
                    <h2 className='col-container-font h2-size mb-0'>Our <span className='col-secondary'>Journey</span></h2>
                </div>
                <div className='d-flex flex-row justify-content-center align-items-center outer-journey-slide'>
                    {shouldShowLeftArrow && <LeftArrow style={{cursor:"pointer"}} className="m-r-20" onClick={slideLeft} />}
                    <div id="journeyContainer" className='journey-slide d-flex flex-row'>
                    {data.map(each => {
                        return <div id="childJourney" key={each.id} className="journey-slide-item">
                                    <p className="text-12 col-container-font mb-1">{each.date} <br /><span className='col-secondary'>{each.title}</span></p>
                                    <hr className="journey-line mt-0 mb-0" />
                                    <p className="text-10 font mt-1">{each.content}</p>
                                    <ul className='p-l-15'>
                                        {each.sublist.map((list, index) => {
                                            return <li key={index} className='text-10 font '><span className='font-weight-7'>{list.title}</span></li>
                                        })}
                                    </ul>
                                </div>
                    })}
                    </div>
                    {shouldShowRightArrow && <LeftArrow style={{rotate:"180deg", cursor:"pointer"}} onClick={slideRight} className="m-l-20" />}
                </div>
            </div>
        </div>
    )
}

export default OurJourney